export const lerp = (min, max, factor) => min * (1 - factor) + max * factor;

export const normalize = (min, max, value) => (value - min) / (max - min);

export const clamp = (value, min, max) => Math.max(Math.min(value, max), min);

export const mapValue = (value, fromMin, fromMax, toMin, toMax) => {
  const factor = normalize(fromMin, fromMax, value);

  return lerp(toMin, toMax, factor);
};

export const lerpByStep = (start, end, factor, step) => {
  const steps = (end - start) / step;
  const value = Math.round(lerp(0, steps, factor));
  const stepFactor = normalize(0, steps, value);

  return lerp(start, end, stepFactor);
};

export const getPowerOfTen = numberOfZeros => 10 ** numberOfZeros;

export const findNextMultipleOfTen = (start, numberOfZeros) =>
  Math.ceil((start + getPowerOfTen(numberOfZeros - 1)) / getPowerOfTen(numberOfZeros)) * getPowerOfTen(numberOfZeros);
